import { Component, HostListener } from '@angular/core';
import { APPCONFIG } from '../../config'
import { TranslateService } from '@ngx-translate/core';
//import { ConfigsListComponent} from '../../configurations/configsList.component';
import { from } from 'rxjs/observable/from';
import { HttpService } from '../../shared/services/http.service';
import {SessionHandler} from '../../shared/services/session-handler.service';
import { AuthService } from "angularx-social-login";
import { Item } from 'angular2-multiselect-dropdown/menu-item';
declare const gapi: any;
declare var window: any;

@Component({
    selector: 'my-app-header',
    styles: [],
    template: require('./header.component.html'),
    providers: [HttpService, SessionHandler]
})

export class AppHeaderComponent {
    AppConfig: any;
    profilePicURL:string;
    //SelectedValue:any;
    private disabled: boolean = false;
    private items: Array<any> =
   [
     { name: 'EN', value: 'English', disabled: false },
     { name: 'IT', value: 'Italian', disabled: false },
     { name: 'DE', value: 'German', disabled: false },
     { name: 'FR', value: 'French', disabled: false },
     { name: 'PL', value: 'Polish', disabled: false },
   ];
   private item: string = 'English';
   // translate: TranslateService;

    constructor(public translate: TranslateService, private authService: AuthService){
    }

    changeLanguage(value: any) {
        console.log(value.value);
        localStorage.setItem('selectedValue', value.value);
        if(value.value === 'English'){
        this.translate.use('en');
       
        }else if(value.value === 'Italian'){
            this.translate.use('it');
            console.log(value.value);
        }else if(value.value === 'German'){
            this.translate.use('de');
        }else if(value.value === 'French'){
            this.translate.use('fr');
        }else if(value.value === 'Polish'){
            this.translate.use('pl');
        }
        console.log('Selected value is: ', value)
      }

    

    getProfilePic(){
        let src = this.profilePicURL;
        

        if(!src){
          src =  "https://atjoin.in/images/default.png";
        }
        // alert(src);
        return src;
    }

    ngOnInit() {
        let val = localStorage.getItem('selectedValue');
        if(val != this.item){
            this.item = val;
        }
         if(this.item == null){
            this.item = 'English';
        }
        this.AppConfig = APPCONFIG;
        this.authService.authState.subscribe((user) => {
			this.profilePicURL = user.photoUrl;
		});
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/header/header.component.ts